export default (amount, percentage) => Number(percentage) ? Number(amount / 100 * (100 - Number(percentage))) : Number(amount)
